// extracted by css-extract-rspack-plugin
export default {"lastEditInfoContainer":"MarkdownLastEditedBy-module__lastEditInfoContainer__TLH5E","mutedEditorLink":"MarkdownLastEditedBy-module__mutedEditorLink__fvMbU"};